import { ProductFiltersMobile } from "@/components/ProductFiltersSidebar";
import Group from "@/tpo/Group";
import SortMenu from "@/tpo/SortMenu";
import { Search } from "@/tpo/TextInput";

export default function LearningHubListToolbar({
  allFilters,
  validatedFilters,
  toggleFilter,
  resetFilters,
  filtersTitle = "Filters",
  getFilterLabel,
  search,
  onSearchChange,
  sortControls,
  showFilters = true
}) {
  return (
    <Group
      gap={8}
      alignItems="center"
      justifyContent={["flex-start", "flex-end", "flex-end"]}
      flexWrap="wrap"
      width="100%"
    >
      {showFilters && (
        <ProductFiltersMobile
          allFilters={allFilters}
          validatedFilters={validatedFilters}
          toggleFilter={toggleFilter}
          onReset={resetFilters}
          filtersTitle={filtersTitle}
          getFilterLabel={getFilterLabel}
        />
      )}
      <Search
        value={search}
        onChange={onSearchChange}
        maxWidth={[null, null, 350]}
        minWidth={302}
        flex="0 1 auto"
      />
      <SortMenu
        value={sortControls.sort}
        setValue={sortControls.setSort}
        open={sortControls.sortMenuOpen}
        setOpen={sortControls.setSortMenuOpen}
        options={sortControls.sortOptions}
        placeholder="Sort By"
      />
    </Group>
  );
}
